import { useTranslations } from "next-intl"
import z from "zod"
import { electricityMeterPointIdSchema, gasMeterPointIdSchema } from "@/features/meter-points"
import { getNameSchema } from "@/schemas/getNameSchema"

export function useMeterPointEligibilitySchemas() {
    const t = useTranslations("MeterPointEligibility")

    const personNameFields = {
        givenName: getNameSchema({
            requiredErrorMessage: t("givenNameRequired"),
            invalidErrorMessage: t("givenNameInvalid"),
        }),
        familyName: getNameSchema({
            requiredErrorMessage: t("familyNameRequired"),
            invalidErrorMessage: t("familyNameInvalid"),
        }),
    }

    const electricitySchema = z.object({
        meterPointId: electricityMeterPointIdSchema,
        ...personNameFields,
    })

    const gasNormalSchema = z.object({
        meterPointId: gasMeterPointIdSchema,
        ...personNameFields,
        meterSerialNumber: z.string().optional().default(""),
        address: z.object({
            addrNumStreet: z.string().optional().default(""),
            addrPostCode: z.string().optional().default(""),
            addrCityLabel: z.string().optional().default(""),
            fullAddress: z.string().optional().default(""),
        }),
    })

    const gasSerialSchema = z.object({
        meterPointId: z.string().optional().default(""),
        ...personNameFields,
        meterSerialNumber: z
            .string({ error: t("meterSerialNumberRequired") })
            .min(1, t("meterSerialNumberRequired")),
        address: z.object({
            addrNumStreet: z.string({ error: t("addressStreetRequired") }),
            addrPostCode: z.string({ error: t("addressPostcodeRequired") }),
            addrCityLabel: z.string({ error: t("addressCityRequired") }),
            fullAddress: z.string().optional().default(""),
        }),
    })

    return { electricitySchema, gasNormalSchema, gasSerialSchema }
}

useMeterPointEligibilitySchemas.messages = ["MeterPointEligibility"] as const
